import { InjectionToken } from '@angular/core';

export const INSTANCE_NAME_TOKEN = new InjectionToken<string>('PROJECT_NAME');
